import {
  getTwoLetterISOLanguageName,
  getCultureCode,
  UserSettings,
  constants,
} from '@dustin-web/microsite-config'
import React from 'react'
import { useCookieState } from './use-cookie-state'
import { useSiteContext } from './use-site-context'

export const UserSettingsContext = React.createContext<UserSettings | null>(null)
export const useUserSettings = () => {
  const context = React.useContext(UserSettingsContext)
  const { setCookie } = useCookieState()
  const { isProxied } = useSiteContext()

  if (!context) {
    throw new Error('useUserSettings must be used within a UserSettingsContext')
  }

  const derivedData = buildUserContextHelper(context)

  const setShowPricesInclVat = (includeVat: boolean) => {
    setCookie(constants.cookies.userSettings.showPriceIncludingVat, includeVat, {
      expireInOneYear: true,
    })
    const searchParams = new URLSearchParams(window.location.search)
    const originUrl = new URL(window.location.href)
    if (searchParams.has('priceinclusivevat')) {
      const searchParams = new URLSearchParams(originUrl.searchParams)

      searchParams.set('priceinclusivevat', includeVat ? '1' : '0')
      originUrl.search = searchParams.toString()
    }
    if (!isProxied) {
      if (searchParams.has('priceinclusivevat')) {
        window.location.href = originUrl.toString()
        return
      }
      window.location.reload()
      return
    }
    const include = includeVat.toString()
    const url = `/account/updatevat?include=${include}&returnurl=${encodeURIComponent(
      originUrl.pathname + originUrl.search
    )}`

    window.location.href = url
  }

  return {
    ...context,
    ...derivedData,
    setShowPricesInclVat,
  }
}

const buildUserContextHelper = (context: UserSettings) => {
  const twoLetterISOLanguageName = getTwoLetterISOLanguageName(context.language)
  const cultureCode = getCultureCode(context.language)

  return { twoLetterISOLanguageName, cultureCode }
}
